var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoxOutlineBlankLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 2.49219V16.5078H1.99219V2.49219H16.0078ZM16.0078 0.5H1.99219C1.44531 0.5 0.976562 0.695313 0.585938 1.08594C0.195312 1.47656 0 1.94531 0 2.49219V16.5078C0 17.0547 0.195312 17.5234 0.585938 17.9141C0.976562 18.3047 1.44531 18.5 1.99219 18.5H16.0078C16.5547 18.5 17.0234 18.3047 17.4141 17.9141C17.8047 17.5234 18 17.0547 18 16.5078V2.49219C18 1.94531 17.8047 1.47656 17.4141 1.08594C17.0234 0.695313 16.5547 0.5 16.0078 0.5Z",
    fill: "#8E8E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOutlineBlankLight);
export default __webpack_public_path__ + "static/media/check_box_outline_blank_light.595ebb82e3bda6a461f01f216ae847ac.svg";
export { ForwardRef as ReactComponent };